/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable no-undef */
import { motion } from 'framer-motion';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { InitialIcon } from '../../redux/helper/IconGenerator';
import { InitialMaker } from '../../redux/helper/InitialMaker';
import CustomToast from '../AlertPopup';
import HeaderContext from '../Context/HeaderContext';

function Header() {
    const [loggedIn, setloggedIn] = useState(false);
    const [logoutDropdown, setLogoutDropdown] = useState(false);
    const [UserData, setUserData] = useState(null);
    const {
        isPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        collapsed,
        setcollapsed,
    } = useContext(HeaderContext);

    React.useEffect(() => {
        if (JSON.parse(localStorage.getItem('user'))) {
            setloggedIn(true);
            setUserData(JSON.parse(localStorage.getItem('user')));
        }
    }, []);
    function Message() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {ErrorMessage || SuccessMessage}
            </p>
        );
    }

    const capitalizeFirstChracter = (string) => {
        let finalString = '';
        string.split('_').forEach((final) => {
            finalString += final.charAt(0).toUpperCase();
        });
        return finalString;
    };

    const GetRoleName = () => {
        let name = '';
        if (UserData !== null) {
            // const temp = UserData.profile.roles.split('_');
            name = ['area_sales_engineer'].includes(UserData.profile.roles) ? capitalizeFirstChracter(UserData.profile.roles) : capitalizeFirstChracter(UserData.profile.roles).replace('S', 'B');
            // for (const i in temp) {
            //     name += temp[i][0].toUpperCase();
            // }
        }
        return name;
    };
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-[#FFFFFF] sticky top-0 left-0"
            style={{ zIndex: isPopup ? '' : '999' }}
        >
            {
                loggedIn && (ErrorMessage !== '' || SuccessMessage !== '') && (
                    <CustomToast
                        open
                        color={colorValue ? colorValue === 'warning' ? '#E29300' : '#ED1C24' : undefined}
                        message={<Message />}
                        setopen={() => {
                            SetErrorMessage('');
                            SetSuccessMessage('');
                            setcolorValue(false);
                        }}
                    />
                )
            }
            <div className="py-[18px] px-12 flex items-center justify-between border-b border-[#EBEBEB]">

                <div className="flex">
                    <motion.img
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        src="/images/Icon-feather-menu.svg"
                        alt="icon"
                        className={`pr-6 cursor-pointer hamburger-menu ${loggedIn ? '' : 'hidden'}`}
                        onClick={() => {
                            setcollapsed(!collapsed);
                            localStorage.setItem('collapse', Boolean(!collapsed));
                        }}
                    />
                    <Link to="/">
                        <motion.img
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            src="/images/Logo.png"
                            alt="icon"
                        />
                    </Link>
                </div>

                {loggedIn && (
                    <div
                        className="flex items-center cursor-pointer relative"
                        onClick={() => setLogoutDropdown(!logoutDropdown)}
                    >
                        {/* <motion.img
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            src="/images/Group-7346.svg"
                            alt="icon"
                        /> */}
                        <InitialIcon initials={GetRoleName()} widthValue="30" heightValue="30" font="10" color="090406" />

                        <p className="text-lg font-normal text-[#555259] px-2">{UserData?.profile?.first_name}</p>

                        <motion.img
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            src="/images/chevron-red-down.svg"
                            alt="icon"
                        />

                        {logoutDropdown
                        && (
                            <div className="rounded-[10px] bg-[#FFFFFF] shadow-s2 absolute w-[200px] right-[-8px] flex justify-center px-5 py-4 cursor-default" style={{ top: '50px' }}>
                                <button
                                    type="button"
                                    className="w-[110px] h-[33px] border border-[#090406] rounded flex items-center justify-center cursor-pointer"
                                    onClick={() => {
                                        localStorage.clear();
                                        window.location.reload();
                                    }}
                                >
                                    <img src="/images/Iconawesome-power-off.png" alt="icon" />
                                    <span className="text-xs2 font-semibold text-[#090406] pl-1.5">Logout</span>
                                </button>
                            </div>
                        ) }
                    </div>
                )}
            </div>
        </motion.div>
    );
}

export default Header;
